/*
 * Datos que el build deja escritos en el HTML (ver primeraFotoDelBuild.ts y el
 * plugin de vite.config.ts). Existen para quien entra por primera vez: en una
 * visita repetida el que manda es `sessionStorage`, que es de esta sesion.
 *
 * El porque, medido en produccion: la portada no podia pintar nada hasta que
 * volvia su consulta, sobre el segundo de haber entrado, porque antes hay que
 * descargar y arrancar el bundle. Con los datos ya en la pagina, el primer
 * render de React ya trae contenido en vez de esqueletos. Se marcan como
 * caducados (`initialDataUpdatedAt: 0` en las paginas), asi que la consulta
 * sale igual y los sustituye en cuanto llega: si el horneado es de ayer, se
 * corrige solo.
 */
type VentanaConCache = Window & { __CACHE_HORNEADA__?: Record<string, unknown> };

function leeCacheHorneada<T>(key: string): T | undefined {
  const horneada = (window as VentanaConCache).__CACHE_HORNEADA__;
  return horneada && key in horneada ? (horneada[key] as T) : undefined;
}

export function readLocalQueryCache<T>(key: string): T | undefined {
  if (typeof window === "undefined") return undefined;
  try {
    const raw = window.sessionStorage.getItem(key);
    if (raw) return JSON.parse(raw) as T;
  } catch {
    /* incognito restringido o JSON roto: queda el horneado */
  }
  try {
    return leeCacheHorneada<T>(key);
  } catch {
    return undefined;
  }
}

export function writeLocalQueryCache<T>(key: string, value: T): void {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.setItem(key, JSON.stringify(value));
  } catch {
    // No-op: evitar romper render por cuota/serialización.
  }
}

export function readLocalUiState<T>(key: string): T | undefined {
  return readLocalQueryCache<T>(key);
}

export function writeLocalUiState<T>(key: string, value: T): void {
  writeLocalQueryCache<T>(key, value);
}

export function devLogQueryPerf(label: string, startMs: number, rows: number): void {
  if (!import.meta.env.DEV) return;
  const elapsed = Math.round(performance.now() - startMs);
  // eslint-disable-next-line no-console
  console.debug(`[perf] ${label}: ${elapsed}ms · rows=${rows}`);
}
